module.exports = __webpack_public_path__ + "static/img/design-bg.c77c5b44.png";